import React from 'react';

function About() {
  return (
    <div className="container">
      <h1>Contact us</h1>
      <p>Please drop an email to aiasapsolutions@gmail.com</p>
      {/* Add your content here */}
    </div>
  );
}

export default About;